const TransactionAccessRetrService = function ($resource, $window) {
    return $resource(
        __baseApiUrl__ + "/participant-web-services/rest/primaryPlan/hasTxnAccess/:txnCode/",
        {
            txnCode: "@txnCode",
            individualId: "@individualId",
            groupId: "@groupId"
        },
        {
            query: {
                //primaryPlan txn Access
                method: "GET",
                isArray: false
            },
            queryWithAccount: {
                //specific plan txn Access
                method: "GET",
                isArray: false,
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/groupTxnAccess/:individualId/:groupId/txnCodes/:txnCode/"
            },

            queryAnyAccount: {
                //ANY plan the participant is in txn Access
                method: "GET",
                isArray: false,
                url: __baseApiUrl__ + "/participant-web-services/rest/hasTxnAccess/:txnCode/"
            },

            queryAnyAccountCurrentContext: {
                // Any plan within the current context
                method: "GET",
                isArray: false,
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/hasTxnAccessInCurrentContext/:txnCode/"
            }
        }
    );
};

TransactionAccessRetrService.$inject = ["$resource", "$window"];
export default TransactionAccessRetrService;
